'use client';

import React, { useCallback } from 'react';
import { CouponInformation } from '../../../../utils';
import { useTranslation } from 'next-i18next';
import type { CouponDetailProps } from './coupon-detail.types';
import { useMapCouponData } from '../../hooks/use-map-coupon-data';
import { useCouponWidgetContent } from '../../../../api';

export const CouponDetail: React.FC<CouponDetailProps> = props => {
    const { t } = useTranslation('flash-sale');
    const { bottomSheetProps, dataType, coupon, variant, isAvailableCoupon } = props;
    const { bottomSheet } = bottomSheetProps;

    const { couponContent: coupons } = useCouponWidgetContent(
        {
            filter: {
                code: { eq: coupon?.code },
            },
        },
        !isAvailableCoupon
    );

    const availableCoupon = coupons?.[0] || coupon;

    const { couponInfo, contentData } = useMapCouponData(dataType, availableCoupon);

    const onAgree = useCallback(() => {
        bottomSheet?.close();
    }, [bottomSheet]);

    if (!couponInfo) {
        return null;
    }

    return (
        <CouponInformation
            coupon={couponInfo}
            content={contentData}
            labelCouponCard={t('text_used')}
            expiredLabel={'HSD'}
            label={t('text_agree', 'Đồng ý')}
            handleAgree={onAgree}
            variant={variant}
            hasShowProgress={variant !== 'eWalletVoucher'}
        />
    );
};
